/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserListItem } from '../../models/user-list-item';

export interface ApiAdminUsersGet$Params {
}

export function apiAdminUsersGet(http: HttpClient, rootUrl: string, params?: ApiAdminUsersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserListItem>>> {
  const rb = new RequestBuilder(rootUrl, apiAdminUsersGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserListItem>>;
    })
  );
}

apiAdminUsersGet.PATH = '/api/Admin/users';
